import React, { useState } from 'react';
import { TextField, Typography, Box, Alert, Paper } from '@mui/material';
import API_ENDPOINTS from '../config/apiConfig';
import { useTranslation } from '../i18n/i18n';
import LoadingButton from './LoadingButton';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!email) {
      setError(t('forgot_email_required'));
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(API_ENDPOINTS.BASEURL + '/api/request-password-reset', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (res.ok) {
        setSuccess(data && data.message ? t(data.message) : t('forgot_success'));
      } else {
        setError(data && data.message ? t(data.message) : t('forgot_error'));
      }
    } catch (err) {
  setError(t('forgot_error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh" px={{ xs: 2, sm: 0 }}>
      <Paper elevation={3} sx={{ p: { xs: 2.5, sm: 4 }, width: '100%', maxWidth: 480, minWidth: { sm: 320 } }}>
        <Typography variant="h5" gutterBottom>{t('forgot_title')}</Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
        <form onSubmit={handleSubmit}>
          <TextField
            label={t('email')}
            type="email"
            fullWidth
            margin="normal"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <LoadingButton
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            loading={loading}
            loadingLabel={t('forgot_sending')}
            sx={{ mt: 2 }}
          >
            {t('forgot_send_button')}
          </LoadingButton>
        </form>
      </Paper>
    </Box>
  );
};

export default ForgotPassword;
